import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type {
  StaffWorkScheduleOverrideQueryParams,
  StaffWorkScheduleOverrideResponse,
  StaffWorkSchedulesQueryParams,
  StaffWorkSchedulesResponse,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const staffWorkScheduleKeys = {
  all: () => ['staffWorkSchedule'] as const,
  weekly: (props: StaffWorkSchedulesQueryParams) =>
    [
      ...staffWorkScheduleKeys.all(),
      'weekly',
      props.url,
      props.staffId,
    ] as const,
  overrides: () => [...staffWorkScheduleKeys.all(), 'override'] as const,
  override: (props: StaffWorkScheduleOverrideQueryParams) =>
    [
      ...staffWorkScheduleKeys.overrides(),
      props.url,
      props.staffId,
      props.locationId,
      props.date,
    ] as const,
};

export const staffWorkScheduleQueries = {
  weekly: (props: StaffWorkSchedulesQueryParams) =>
    queryOptions({
      queryKey: staffWorkScheduleKeys.weekly(props),
      queryFn: () =>
        HttpClient.request<StaffWorkSchedulesResponse>({
          method: 'GET',
          url: props.url,
          params: { staff_id: props.staffId },
        }),
      enabled: !!props.url && !!props.staffId,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
    }),

  override: (props: StaffWorkScheduleOverrideQueryParams) =>
    queryOptions({
      queryKey: staffWorkScheduleKeys.override(props),
      queryFn: () =>
        HttpClient.request<StaffWorkScheduleOverrideResponse>({
          method: 'GET',
          url: `${props.url}/${props.date}`,
          params: { staff_id: props.staffId, location_id: props.locationId },
        }),
      enabled:
        !!props.url && !!props.staffId && !!props.locationId && !!props.date,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
    }),
};
